import { useState } from "react";
import {
  UserPanelHeader,
  UserTable,
  AddUserDialog,
  DeleteUserDialog,
  useUsersPanel,
} from "./users";
import { useDeleteUser } from "../queries";
import { useAuth } from "@/app/providers/useAuth";
import type { User } from "@/services/api/users";

export function UsersPanel() {
  const { account } = useAuth();
  const currentUserEntraId = account?.localAccountId ?? null;
  const [isAddUserDialogOpen, setIsAddUserDialogOpen] = useState(false);
  const [deletingUser, setDeletingUser] = useState<User | null>(null);
  const {
    users,
    categories,
    isLoading,
    isLoadingCategories,
    isUpdatingPermissions,
    sortField,
    sortDirection,
    handleSort,
    handleTogglePermission,
    usersCount,
  } = useUsersPanel();

  const { mutateAsync: deleteUser, isPending: isDeletingUser } =
    useDeleteUser();

  const handleDeleteUser = async () => {
    if (!deletingUser) return;
    await deleteUser(deletingUser.id);
    setDeletingUser(null);
  };

  return (
    <div className="w-full space-y-6">
      <UserPanelHeader
        usersCount={usersCount}
        onAddUserClick={() => setIsAddUserDialogOpen(true)}
      />

      {/* TODO: apply filter by email when BE is ready */}
      {/* <div className="flex items-center gap-3">
        <Input
          placeholder="Filter by email"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="max-w-sm"
        />
      </div> */}

      <div className="rounded-xl border border-grid-200 bg-white shadow-sm">
        <UserTable
          users={users}
          categories={categories}
          sortField={sortField}
          sortDirection={sortDirection}
          isLoading={isLoading}
          isLoadingCategories={isLoadingCategories}
          isUpdatingPermissions={isUpdatingPermissions}
          onSort={handleSort}
          onTogglePermission={handleTogglePermission}
          currentUserEntraId={currentUserEntraId}
          onDelete={setDeletingUser}
        />
      </div>

      <AddUserDialog
        open={isAddUserDialogOpen}
        onOpenChange={setIsAddUserDialogOpen}
        categories={categories}
      />

      <DeleteUserDialog
        open={!!deletingUser}
        user={deletingUser}
        isLoading={isDeletingUser}
        onOpenChange={(open) => {
          if (!open) setDeletingUser(null);
        }}
        onConfirm={handleDeleteUser}
      />
    </div>
  );
}
